import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { TourV2ContentSections } from 'constants/tours'

function useTourV2ContentSectionLabels(): Record<TourV2ContentSections, string> {
  const intl = useIntl()

  return useMemo(() => ({
    [TourV2ContentSections.OVERVIEW]: intl.formatMessage({
      id: 'oCH9bzifoFcHfhNGK-Vn',
      defaultMessage: 'Overview',
      description: 'Tour section label for the overview section on the tour page',
    }),
    [TourV2ContentSections.PREFERRED_PACKAGES]: intl.formatMessage({
      id: 'GVb6siHXsHLrdU82upDF',
      defaultMessage: 'Select your preferred package',
      description: 'Tour section label for selecting preferred package',
    }),
    [TourV2ContentSections.ITINERARY]: intl.formatMessage({
      id: '_d4vYgMOVdC9tOOL1RRS',
      defaultMessage: 'Itinerary',
      description: 'Tour section label for the itinerary section on the tour page',
    }),
    [TourV2ContentSections.VARIATIONS]: intl.formatMessage({
      id: '65xHGAvsQjmEH2FGX3Qr',
      defaultMessage: 'Variations',
      description: 'Tour section label for the variations section in the tours section',
    }),
    [TourV2ContentSections.INCLUSIONS]: intl.formatMessage({
      id: 'omKGISQLvQWx1nTNxpLe',
      defaultMessage: 'Highlights & inclusions',
      description: 'Tour section label for highlights and inclusions section',
    }),
    [TourV2ContentSections.DEPARTURES]: intl.formatMessage({
      id: 'mlr9eHh4Edj3Kffsj2HD',
      defaultMessage: 'Dates & pricing',
      description: 'Tour section label for dates and pricing section in the tours section',
    }),
    [TourV2ContentSections.FINE_PRINT]: intl.formatMessage({
      id: 'NNOmV1zigAt2hY87FMU6',
      defaultMessage: 'Things to know',
      description: 'Tour section label for fine print/things to know section',
    }),
    [TourV2ContentSections.FAQ]: intl.formatMessage({
      id: 't_sAiwVNefk5EVBBQyl2',
      defaultMessage: 'Frequently Asked Questions',
      description: 'Tour section label for FAQ section on the tour offer detail page',
    }),
    [TourV2ContentSections.YOU_MAY_ALSO_LIKE]: intl.formatMessage({
      id: 'tzA0AQ1z7mFzwzZWlKc3',
      defaultMessage: 'You may also like',
      description: 'Tour section label for the recommendations section',
    }),
    [TourV2ContentSections.REVIEWS]: intl.formatMessage({
      id: 'P04m11WUmM7EEIZiGgp8',
      defaultMessage: 'Reviews',
      description: 'Tour section label for reviews section on the tour offer detail page',
    }),
    [TourV2ContentSections.ADDITIONAL_WAYS]: intl.formatMessage({
      id: 'tcUBzb-eYH19TkPzLba3',
      defaultMessage: 'Additional ways to experience this tour',
      description: 'Tour section label for additional tour variations in the tours section',
    }),
    [TourV2ContentSections.SIMILAR_TOURS]: intl.formatMessage({
      id: 'LVOXuvrKCEqgupMSOS6i',
      defaultMessage: 'View Similar tours',
      description: 'Tour section label for similar tours section on the tour page',
    }),
    [TourV2ContentSections.DEPARTURE_DATES]: '',
    [TourV2ContentSections.GALLERY]: '',
  }), [intl])
}

export default useTourV2ContentSectionLabels
